import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";
import { token } from "@filadd/phi-plus-styled-system/tokens";
import { X } from "@phosphor-icons/react";
import Image from "next/image";
import { useEffect, useState } from "react";
export const ModalNotification = ({ body, title, image_url: imageUrl, action, onOpen, onClose, }) => {
    const [open, setOpen] = useState(true);
    const closeModal = () => setOpen(false);
    useEffect(() => {
        onOpen();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (_jsxs(Dialog.Root, { open: open, onExitComplete: onClose, closeOnInteractOutside: true, children: [_jsx(Dialog.Backdrop, {}), _jsx(Dialog.Positioner, { children: _jsxs(Dialog.Content, { className: css({
                        p: 6,
                        pt: 10,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2,
                    }), children: [_jsx(Dialog.CloseTrigger, { className: css({
                                p: 1,
                                position: "absolute",
                                top: 2,
                                right: 2,
                                cursor: "pointer",
                            }), onClick: closeModal, children: _jsx(X, { width: 24, height: 24, color: token("colors.neutral.400") }) }), imageUrl != null ? (_jsx("div", { className: css({
                                height: 48,
                                position: "relative",
                                alignSelf: "stretch",
                            }), children: _jsx(Image, { src: imageUrl, alt: title !== null && title !== void 0 ? title : "", fill: true }) })) : null, title != null ? (_jsx("div", { className: css({ textStyle: "titleLarge" }), children: title })) : null, _jsx("div", { className: css({
                                textStyle: title == null ? "titleLarge" : "body",
                            }), children: body }), action != null ? (_jsx("a", { href: action.url, children: _jsx(Button, { variant: "solid", onClick: closeModal, children: action.label }) })) : null] }) })] }));
};
//# sourceMappingURL=ModalNotification.js.map